var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import LoginModal from "./modals/loginModal";
import images from "../utils/Images";
import ForgetPinModal from "./modals/ForgetPinModal";
import { useDispatch, useSelector } from "react-redux";
import { autoLogin, tokenKey } from "../store/slices/userSlice";
import useChaseListNavigate from '../hooks/useChaseListNavigate';
import { Popover } from "@mui/material";
import useFetchNotification from "../hooks/useFetchNotification";
import { toast } from "react-toastify";
import Spinner from "./Spinner";
var Navbar = function () {
    var chaseListNavigate = useChaseListNavigate();
    var _a = useState(""), noticeText = _a[0], setNoticeText = _a[1];
    var _b = useState(""), noticeTitle = _b[0], setNoticeTitle = _b[1];
    var _c = React.useState(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var dispatch = useDispatch();
    var _d = useFetchNotification(), fetchNotice = _d.fetchNotice, loadingNotice = _d.loading, notice = _d.notice, errorNotice = _d.error;
    var _e = useState(false), showLoginModal = _e[0], setShowLoginModal = _e[1];
    var _f = useState(true), showSearchButton = _f[0], setShowSearchButton = _f[1];
    var _g = useState(true), showSocialButton = _g[0], setShowSocialButton = _g[1];
    var _h = useState(false), showForgetPinModal = _h[0], setShowForgetPinModal = _h[1];
    var _j = useState(false), userLoggedIn = _j[0], setUserloggedIn = _j[1];
    var isLoggedIn = useSelector(function (state) { return state.user.isLoggedIn; });
    var username = useSelector(function (state) { return state.user.username; });
    var publicId = useSelector(function (state) { return state.user.publicId; });
    var currentPage = useSelector(function (state) { return state.site.currentPage; });
    useEffect(function () {
        if (notice) {
            setNoticeText(notice.description);
            setNoticeTitle(notice.title);
        }
    }, [notice]);
    var handleNotificationClick = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (anchorEl) {
                        handleClose();
                    }
                    else {
                        setAnchorEl(event.currentTarget);
                    }
                    return [4 /*yield*/, fetchNotice()];
                case 1:
                    _a.sent();
                    if (errorNotice) {
                        toast.error(errorNotice);
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    React.useEffect(function () {
        var alreadyLoggedIn = localStorage.getItem(tokenKey);
        if (isLoggedIn === false) {
            if (alreadyLoggedIn) {
                setUserloggedIn(true);
                dispatch(autoLogin());
            }
        }
        if (isLoggedIn) {
            setShowLoginModal(false);
        }
    }, [isLoggedIn,]);
    React.useEffect(function () {
        setUserloggedIn(isLoggedIn);
        if (isLoggedIn) {
            setShowLoginModal(false);
        }
    }, [isLoggedIn, publicId]);
    var pageChangeHandle = function (path) {
        if (path === "/#/search") {
            setShowSearchButton(false);
        }
        if (path === "/#/social") {
            setShowSocialButton(false);
        }
        if (showSearchButton === false) {
            setShowSearchButton(true);
        }
        if (showSocialButton === false) {
            setShowSocialButton(true);
        }
        chaseListNavigate(path);
    };
    var pageChangeHandleLinks = function (path, isExternal) {
        if (isExternal === void 0) { isExternal = false; }
        if (isExternal) {
            window.open(path, '_blank');
            return;
        }
        chaseListNavigate(path);
    };
    var loginHandle = function (value) {
        setShowLoginModal(value);
        setShowForgetPinModal(false);
    };
    var userloginHandle = function () {
        // setUserloggedIn(true);
    };
    var forgetPinModalHandle = function (value) {
        setShowLoginModal(false);
        setShowForgetPinModal(value);
    };
    var getEmail = function (email) {
        console.log("link sent to", email);
    };
    return (_jsxs("div", { children: [_jsxs("div", { className: "flex h-[53px] md:h-[80px] items-center justify-between px-[18px] my-2 md:my-4 header_nav_bar", children: [_jsxs("div", { className: "flex flex-col", children: [_jsxs("div", { className: "flex flex-row", children: [_jsx("h2", { children: "Hello," }), "\u270B", _jsx("h2", { children: username })] }), _jsxs("div", { className: "flex flex-row", children: [_jsx("h2", { className: "green-text-color text-[16px] font-semibold", children: "Welcome" }), "\u00A0", _jsx("h2", { className: "blue-text-color text-[16px] font-semibold", children: "back!" })] })] }), _jsx("div", { className: "flex flex-col", children: _jsx("img", { src: images.brandHeaderCropped, alt: "Notifications", className: "h-[60px] cursor-pointer", onClick: handleNotificationClick }) })] }), showLoginModal && (_jsx(LoginModal, { loginUser: userloginHandle, closeModal: function () { return loginHandle(false); }, openForgetPinModal: function () { return forgetPinModalHandle(true); } })), showForgetPinModal && (_jsx(ForgetPinModal, { openLoginModal: function () { return loginHandle(true); }, emailHandle: function (email) { return getEmail(email); }, closeModal: function () { return forgetPinModalHandle(false); } })), _jsxs(Popover, { open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                }, children: [notice && _jsxs("div", { className: "p-4", children: [_jsx("div", { className: "text-[#333333] text-[14px] font-medium", children: noticeTitle }), _jsx("div", { className: "text-[#333333] text-[14px] font-normal", dangerouslySetInnerHTML: { __html: noticeText } })] }), loadingNotice && _jsx("div", { className: "p-4", children: _jsx(Spinner, {}) })] })] }));
};
export default Navbar;
